import { Component, input, computed } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-calls-locations-tab',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    { provide: TabComponent, useExisting: CallsLocationsTabComponent },
  ],
  templateUrl: './calls-locations-tab.component.html',
  styleUrl: './calls-locations-tab.component.scss',
})
export class CallsLocationsTabComponent extends TabComponent {
  override name = this.dictionaryService.get('CallsLocations');

  userId = input.required<string>();
  endpoint = computed(() => `/trackers/tables/calls-location/${this.userId()}`);

  public async main(): Promise<void> {}
}
